import React from 'react';
import { Button, Popover } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';

export default function InformacionUbicaciones({ caso, historica = false }) {
  const reglas = {
    1: 'Seleccionar un departamento y una ciudad para el origen, y un departamento y una ciudad para el destino.',
    2: 'Seleccionar uno o varios departamentos para cada punto del traslado. Puede incluir todas las ciudades de esos departamentos o elegir ciudades específicas.',
    3: 'Seleccionar un departamento y una o varias ciudades de ese departamento para cada punto del traslado.',
  };
  return <Popover title={historica ? 'Ubicaciones permitidas en esta versión' : 'Ubicaciones permitidas para este paciente'} trigger={['hover', 'focus', 'click']}
    content={<div style={{ maxWidth: 'min(320px, calc(100vw - 64px))' }}>
      <p>{historica ? 'Al guardar esta versión, las reglas del cliente permitían:' : 'Las reglas del cliente de este paciente permiten:'}</p>
      <p>{reglas[Number(caso)] || 'Consulte la configuración de ubicaciones del cliente.'}</p>
      <p>El origen y el destino se configuran por separado. Las instituciones y los lugares temporales deben estar en los departamentos y ciudades seleccionados.</p>
      <p style={{ marginBottom: 0 }}>La institución inicial puede reemplazarse por otra institución permitida al programar el traslado.</p>
    </div>}>
    <Button type="text" shape="circle" icon={<InfoCircleOutlined style={{ color: '#1677ff' }} />}
      aria-label="Información sobre las ubicaciones permitidas" />
  </Popover>;
}
